import type { AxiosResponse } from "axios";
import { executePost } from "../../../../utils/appUtils";

const optOutQueryAndReqPinApi = (isOptOutParams): Promise<AxiosResponse> => {
    const optOutQueryAndReqPin = `/participant-web-services/rest/partialauth/optOutQueryRequestPin/${isOptOutParams.optOut}`;
    return executePost(optOutQueryAndReqPin, "ooptOutQueryAndReqPinFault", { ...isOptOutParams });
};
export default optOutQueryAndReqPinApi;
